export default {
    namespaced: true,

    state: {
        userInfo: JSON.parse(localStorage.getItem('userInfo')) || null,
    },

    getters: {
        userInfo: (state) => state.userInfo || {},
    },

    mutations: {
        setUserInfo(state, payload) {
            state.userInfo = payload;
            localStorage.setItem('userInfo', JSON.stringify(payload));
        },
        clearAuth(state) {
            state.userInfo = null;
            localStorage.removeItem('userInfo');
            localStorage.removeItem('token');
        },
    },

    actions: {
        fetchUser({ commit }, userId) {
            const token = localStorage.getItem('token');
            if (!token) {
                console.warn('No access token found. Skipping fetchUser.');
                return Promise.resolve();
            }

            return fetch(`${process.env.VUE_APP_URL_DEV}/api/users/${userId}`, {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    if (!response.ok) {
                        throw new Error(`Failed to fetch user: ${response.statusText}`);
                    }
                    return response.json();
                })
                .then((data) => {
                    commit('setUserInfo', data.data);
                })
                .catch((error) => {
                    console.error('Error fetching user:', error);
                    commit('clearAuth');
                });
        },
        updateUser({ commit }, updatedUser) {
            commit('setUserInfo', updatedUser);
        },
        logout({ commit }) {
            commit('clearAuth');
        },
    },
};
